// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-box {
    background: white;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
}

.login-box h1 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
    font-size: 24px;
}

.login-type-toggle {
    display: flex;
    gap: 10px;
    margin-bottom: 30px;
}

.login-type-toggle button {
    flex: 1 1;
    padding: 10px;
    background: #f0f0f0;
    color: #666;
    border: 2px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 0;
    transition: all 0.3s ease;
}

.login-type-toggle button.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

.login-type-toggle button:hover:not(.active) {
    background: #e0e0e0;
    border-color: #999;
}

.login-box h2 {
    color: #666;
    margin-bottom: 20px;
    font-size: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 500;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    box-sizing: border-box;
}

.form-group input:focus {
    outline: none;
    border-color: #667eea;
}

button {
    width: 100%;
    padding: 12px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
}

button:hover:not(:disabled) {
    background: #5568d3;
}

button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

button.secondary {
    background: #6c757d;
    margin-top: 10px;
}

button.secondary:hover:not(:disabled) {
    background: #5a6268;
}

.error {
    background: #fee;
    color: #c33;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
}

.success {
    background: #efe;
    color: #3c3;
    padding: 12px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
}

.info-text {
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;AACjE;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".login-container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.login-box {\n    background: white;\n    padding: 40px;\n    border-radius: 10px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n    width: 100%;\n    max-width: 400px;\n}\n\n.login-box h1 {\n    text-align: center;\n    color: #333;\n    margin-bottom: 20px;\n    font-size: 24px;\n}\n\n.login-type-toggle {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.login-type-toggle button {\n    flex: 1;\n    padding: 10px;\n    background: #f0f0f0;\n    color: #666;\n    border: 2px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    margin-top: 0;\n    transition: all 0.3s ease;\n}\n\n.login-type-toggle button.active {\n    background: #667eea;\n    color: white;\n    border-color: #667eea;\n}\n\n.login-type-toggle button:hover:not(.active) {\n    background: #e0e0e0;\n    border-color: #999;\n}\n\n.login-box h2 {\n    color: #666;\n    margin-bottom: 20px;\n    font-size: 20px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n    font-weight: 500;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 16px;\n    box-sizing: border-box;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\nbutton {\n    width: 100%;\n    padding: 12px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\nbutton:hover:not(:disabled) {\n    background: #5568d3;\n}\n\nbutton:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\nbutton.secondary {\n    background: #6c757d;\n    margin-top: 10px;\n}\n\nbutton.secondary:hover:not(:disabled) {\n    background: #5a6268;\n}\n\n.error {\n    background: #fee;\n    color: #c33;\n    padding: 12px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    font-size: 14px;\n}\n\n.success {\n    background: #efe;\n    color: #3c3;\n    padding: 12px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    font-size: 14px;\n}\n\n.info-text {\n    color: #666;\n    font-size: 14px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
